module.exports = __webpack_public_path__ + "img/age.a9f409cd.svg";